import { openBlock as c, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 4"
}, t = /* @__PURE__ */ e("circle", {
  cx: "1.5",
  cy: "2",
  r: "1.5",
  fill: "currentColor"
}, null, -1), l = /* @__PURE__ */ e("circle", {
  cx: "6",
  cy: "2",
  r: "1.5",
  fill: "currentColor"
}, null, -1), n = /* @__PURE__ */ e("circle", {
  cx: "10.5",
  cy: "2",
  r: "1.5",
  fill: "currentColor"
}, null, -1), s = [
  t,
  l,
  n
];
function i(_, d) {
  return c(), o("svg", r, [...s]);
}
const f = { render: i };
export {
  f as default,
  i as render
};
